<template>
  <IQOSModal>
    <template #title>
      {{ $t("add_discount.title") }}
    </template>
    <div>
      <BaseSelect fullWidth class="mt-16" v-model="target.menu_id">
        <option v-for="menu in menus" :key="menu._id" :value="menu._id">
          {{ menu.title }}
        </option>
      </BaseSelect>
      <BaseSelect
        class="mt-8"
        fullWidth
        v-if="target.menu_id"
        v-model="target.category_id"
      >
        <option :value="null">{{ $t("add_discount.all_categories") }}</option>
        <option
          v-for="category in selectedMenu.categories"
          :key="category._id"
          :value="category._id"
        >
          {{ category.name }}
        </option>
      </BaseSelect>
      <BaseSelect
        class="mt-8"
        fullWidth
        v-model="target.product_id"
        :disabled="!target.category_id"
      >
        <option :value="null">
          {{ $t("add_discount.all_products") }}
        </option>
        <template v-if="target.category_id">
          <option
            v-for="product in selectedCategoryProducts"
            :key="product._id"
            :value="product._id"
          >
            {{ product.name }}
          </option>
        </template>
      </BaseSelect>
      <BaseSelect
        class="mt-8"
        fullWidth
        v-model="target.modificator_id"
        :disabled="!target.product_id"
        v-if="selectedProduct && mergedPriceGroups.length > 0"
      >
        <option :value="null">
          {{ $t("add_discount.all_modificators") }}
        </option>
        <template v-if="target.product_id">
          <option
            v-for="mod in mergedPriceGroups"
            :key="mod._id"
            :value="mod._id"
          >
            {{ mod.name }}
          </option>
        </template>
      </BaseSelect>
      
      <BaseUnitInput
        class="mt-16 w-100"
        fullWidth
        type="number"
        :readonly="false"
        :unitPlaceholder="'%'"
        v-model.number="discount"
        :placeholder="$t('add_discount.discount_ph')"
      />
    </div>
    <div class="flex-row mt-16">
      <v-date-picker
        class="date-picker"
        v-model="period_start"
        :locale="calendarLocale"
      />
      <!-- <BaseInput :readonly="false" placeholder="Дата початку" /> -->
      <div class="line-split">-</div>
      <!-- <BaseInput :readonly="false" placeholder="Дата кінця" /> -->
      <v-date-picker
        class="date-picker"
        v-model="period_end"
        :locale="calendarLocale"
      />
    </div>
    <template #actions>
      <BaseButton 
        variant="secondary" 
        color="v1-grey-3"
        size="md"
        class="w-100" 
        @click="$emit('close')">
        {{ $t("add_campaign.cancel") }}</BaseButton
      ><BaseButton
        variant="secondary"
        color="green-5"
        size="md"
        @click="createPromotion"
        class="w-100"
        :disabled="!canCreate"
        >{{ $t("add_campaign.confirm") }}</BaseButton
      >
    </template>
  </IQOSModal>
</template>
<script>
import IQOS from "@/components/IQOS.vue";
import BlackSelect from "@/components/BlackSelect.vue";
import DashboardButton from "@/components/DashboardButton.vue";

import BlackInput from "@/components/BlackInput.vue";

import PromotionsAPI from "@/api/promotions";

import moment from "moment";

export default {
  components: {
    IQOS,
    BlackSelect,
    DashboardButton,
    BlackInput,
  },
  data() {
    return {
      target: {
        menu_id: null,
        category_id: null,
        product_id: null,
        modificator_id: null,
      },
      period_start: moment().toDate(),
      period_end: null,
      discount: null,
    };
  },
  watch: {
    "target.menu_id"() {
      this.target.category_id = null;
      this.target.product_id = null;
    },
    "target.category_id"() {
      this.target.product_id = null;
    },
  },
  methods: {
    createPromotion() {
      const request_data = {
        target: this.target,
        cafe_id: this.cafe._id,
        discount: this.discount,
      };

      request_data.target.category_id = this.target.category_id || null;
      request_data.target.product_id = this.target.product_id || null;
      request_data.target.modificator_id = this.target.modificator_id || null;

      request_data.target.menu_name = this.selectedMenu.title;
      request_data.target.category_name = this.selectedCategory.name;
      request_data.target.product_name = this.selectedProduct.name;
      if (request_data.target.modificator_id) {
        const item = this.mergedPriceGroups.find(
          (i) => i._id == this.target.modificator_id
        );
        if (item) {
          request_data.target.modificator_name = item.name;
        }
      }
      request_data.period_start = moment(this.period_start).startOf('day').toDate();
      request_data.period_end = moment(this.period_end || new Date()).endOf('day').toDate();

      PromotionsAPI.create(request_data)
        .then((data) => {
          this.$emit("created");

          this.$store.dispatch("auditlog/write", {
            type: "create_discount",
            payload: request_data,
          });
        })
        .catch((err) => {
          alert(err);
        });
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    menus() {
      return this.$store.state.menu.menus;
    },
    selectedMenu() {
      return this.menus.find((m) => m._id == this.target.menu_id);
    },
    selectedCategoryProducts() {
      if (!this.target.category_id) return [];

      return this.selectedMenu.products.filter(
        (p) => p.category_id == this.target.category_id
      );
    },
    calendarLocale() {
      return this.$i18n.locale == "ua" ? "uk" : this.$i18n.locale;
    },
    selectedCategory() {
      if (!this.target.category_id) return { name: null };

      return this.selectedMenu.categories.find(
        (c) => c._id == this.target.category_id
      );
    },
    selectedProduct() {
      if (!this.target.product_id) return { name: null };

      return this.selectedMenu.products.find(
        (p) => p._id == this.target.product_id
      );
    },
    canCreate() {
      return this.target.menu_id && this.discount && this.period_start && this.period_end && moment(this.period_start).startOf('day').isSameOrBefore(moment(this.period_end).endOf('day'));
    },
    mergedPriceGroups() {
      if (!this.selectedProduct) return [];
      if (!this.selectedProduct.price_groups) return [];

      console.log(this.selectedProduct);

      return this.selectedProduct.price_groups.reduce(
        (acc, item) => acc.concat(item.items),
        []
      );
    },
  },
  mounted() {
    this.target.menu_id = this.menus[0]._id;
  },
};
</script>
<style scoped>
.compagin-pop-up-wrapper {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.line-split {
  font-size: 4vh;
  color: #ededed;
  margin: 0 16px;
}
.container-box.iqos-static.flex-row {
  justify-content: space-between;
}
.w-35 {
  width: 35%;
}
.pop-up-message {
  font-size: 2.222vh;
  line-height: 2.5555555555555554vh;
  color: #908f8d;
}
.mb-10 {
  margin-bottom: 1.1111111111111112vh;
}

.date-picker {
  width: 100%;
}
</style>


<style>
.vc-text-base {
  padding: 0.5vh 1vh;
  width: 100%;
  margin-right: 0 !important;
  text-align: center;

  /* width: 10vh !important; */
}
</style>